import { getRoot } from 'mobx-state-tree';

const Views = self => ({
  shouldShowBulkUBP: () => getRoot(self).user?.billing?.isPaid ?? false,
  isEligibleForBulkShow: () => !self.shouldShowBulkUBP() || self.bulkShowCredits > 0,
});

export default Views;
